import React, { Component, useEffect } from "react";
import { useStitchAuth } from "../StitchAuth.js";
import { RoadmapediaLogo } from "../images";
import { NavbarStyles } from "../styles";
import { ModalContext } from "../App.js";
import { Link } from "react-router-dom";

export default function Navbar() {
  const { isLoggedIn, actions } = useStitchAuth();

  const message = "message";

  return (
    <ModalContext.Consumer>
      {({ _, toggleModal }) => (
        <div className="navbarContainerOuter">
          <div className="navbarContainerInner">
            <div className="navbarItemsContainer">
              <div className="navbarItem">
                <Link to="/">
                  <img className="navbarLogo" src={RoadmapediaLogo} />
                </Link>
              </div>
              <div className="navbarItem">{message}</div>
              <div className="navbarItem">Browse</div>
              <div className="navbarItem">
                <Link to="/create">Create</Link>
              </div>
            </div>
            <div className="navbarButton">
              <span>
                {isLoggedIn ? (
                  <div>
                    <span
                      onClick={() => {
                        actions.handleLogout();
                      }}
                    >
                      Logout
                    </span>
                    <Link to="/dashboard">My Dashboard</Link>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        actions.handleEmailLogin({
                          email: "test3@gmail.com",
                          password: "test3@gmail.com",
                        });
                        toggleModal();
                      }}
                    >
                      One Click Login With Dummy Test Account
                    </div>
                    <div
                      onClick={() => {
                        if (!isLoggedIn) {
                          toggleModal();
                        } else {
                          // not actions.handleLogout() anymore
                        }
                      }}
                    >
                      Login Normally
                    </div>
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      )}
    </ModalContext.Consumer>
  );
}
